// Assets
import iconPhone from 'assets/img/icons8-phone-50.png';

// Core modules
import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
// import 'bootstrap/dist/css/bootstrap.min.css';

// Third-party modules
import Base64 from 'Base64';
import QRCode from "react-qr-code";
import { Cookies } from 'react-cookie';
import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js';
import 'draft-js/dist/Draft.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

// Framework modules
import Page from 'components/Page';
import { Badge, Card, CardBody, CardHeader, CardImg, CardLink, CardText, CardTitle, Col, Input, ListGroup, ListGroupItem, Row, Modal, ModalBody, ModalFooter, ModalHeader, Button, FormGroup, Label } from 'reactstrap';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';

// Vortex 
import ViewProjectTasks from './ViewProjectTasks.js';
import ComboBox from './component/ComboBox.js';
import DriveGrid from './ViewDrive/DriveGrid.js';
import DriveGridUploader from './ViewDrive/DriveGridUploader.js';
import FormProject from './FormProject';
import DataAdapter from './adapter/DataAdapter.js';
import VtxEditor from './component/VtxEditor.js';
import NotePad from './component/NotePad.js';
import { getProjectById, getMyNotes } from './adapter/queryStatement.js';
import ViewProjectTaskDetails from './ViewProjectTaskDetails.js';
import ViewProjectTask from './ViewProjectTask.js';

// Constants
const cookie = new Cookies();
const _BACKEND_URL_ = "https://node.renobuilding.ca:3001"

// Variables
var __PROJECT_ID__;
var __PROJECT_TASK_ID__;

class ViewProject extends React.Component {
	notificationSystem = React.createRef();
	constructor(props) {
		super(props);

		if (props.match) {
			__PROJECT_ID__ = this.props.match.params.id;
			__PROJECT_TASK_ID__ = this.props.match.params.task;
		} else {
			__PROJECT_ID__ = this.props.id;
			__PROJECT_TASK_ID__ = this.props.task;
		}

		if (__PROJECT_ID__ == '-1') {
			console.error('Access denied!');
			window.location = '/';
		}

		this.state = {
			modal: false,
			notepadModal: false,
			communicationModal: false,
			conversationModal: false,
			estimateModal: false,
			setAppointmentModal	: false,
			quoteMdal: false,
			quickEditeProjectModal: false,
			quickEditeClientModal: false,
			backdrop: true,
			tasks: [],
			projects: [],
			project_title: '',
			project_description: '',
			project_category: '',
			project_category_1: 0,
			client: 0,
			task: __PROJECT_TASK_ID__,
			refresh: false,
			selectedFile: [],
			current: null,
			mynotes: '',
			othernotes: '',
			receiver_id: 0,
			receiver_tel: '',
			receiver_email: '',
			__ACCESS_V_ACTIONMANAGER__		:	{display:'none'},
			__ACCESS_V_PROJECTINFO__		:	{display:'none'},
			__ACCESS_V_TASKINFO__			:	{display:'none'},
			__ACCESS_V_DRIVE__				:	{display:'none'},
			__SHARELINK: false,
			__ASSIGNTO: false,
			__CLOSEJOB: false,
			__STATUS: false,
			__BUDGET: false,
			__PHON: false,
			__NOTES: false,
			__UPLOAD: false,
			__QUOTE: false,
			__TASK: false,
			__LOCATION: false,
			__CLIENT_INFORMATION: false,
			__DESCRIPTION: false,
			status: 0,
			task_status: 0,
			appointmentDate: '',
			appointmentTime: '',
			templateId: -1,
			templateType: 1,
			editorState: EditorState.createWithContent(
				ContentState.createFromBlockArray(
					convertFromHTML('<table><tr><td>this s test</td></tr></table>')
				)
			),
			convertedText		: '<table><tr><td>TEST</td><td>TEST</td><td>123</td></tr></table>',
			//convertedText		:	'<table><tr><td><b>Reno Building Canada Inc. </b><p><b>O :</b> (416) 821-FREE <br /><b>A :</b> C, 650 Srigley St., Newmarket <br /><b>E :</b> info@renoBuilding.ca <br /><>Prepared by : </> Mahyar T., CEO <br /></p></td><td></td><td><h1>QUOTE</h1></td></tr><tr><td></td><td></td><td><b>Date :</b> 15-12-2022 <br /><b>Quote # :</b> 110-221-Q-451 <br /><b>Updated on :</b> 15-12-2022</td></tr><tr><td></td><td></td><td><b>To :</b> Dr. David Hung <br/><b>Address :</b>116 Conover Ave,Aurora ON(647) 989-5200 <br/><b>Client ID :</b> 5200-DH</td></tr></table><table class="report-table"><tr class="report-table-header" ><th>Item No.</th><th>Description</th><th>Unit</th><th>Amount</th></tr><tr><td>1</td><td>En-suite bathroom: <br/>- Demo, takeout and disposal the shower, vanity, toilet and floor <br/>- Renew 40 by 40 standing shower<br/>- Complete Waterproof the shower area and floor<br/>- Tile the Shower ‘s Floor and walls and grout the tile area<br/>- Tile the bathroom floor and grout<br/>-Tile the Jacuzzi surround<br/>- Plumbing for takeout the old fixtures and install the shower, vanity and toilet<br/>- Electrical for new fan and the shower ceiling light.<br/>- Install the shower glass<br/>- Install a fan for bathroom<br/>- Install other accessories and light.<br/>- Install baseboards<br/>-Cleaning<br/></td><td></td><td>$19,350</td></tr><tr><td>2</td><td>Basement bathroom: <br/>- Demo, takeout and disposal the floor for plumbing <br/>- Install new standing shower <br/>- Tile the bathroom floor and grout<br/>- Plumbing for install the new shower, new toilet and re-install existing vanity <br/>- Cleaning<br/></td><td></td><td></td></tr><tr><td>3</td><td>1-There may have some dust, noise and mud during the construction.<br/>2-Client is taking the responsibility for the Town permit and related costs<br/>3-Client to take out their stuffs from the working area.<br/>4-Client to providing visible materials or pay to contractor based on the store receipt. The selectable materials by client including but not limited the vanity, toilet, shower, fixtures, tiles, glass, accessories, fan, lights, etc. <br/>5-Client to pay 10% on acceptance, 50% on start day and 40% on end day <br/>6-The building materials is under the suppliers’ warranty<br/>7-The shower is warranty for one year. <br/>8-The quote is valid for one month<br/>9-Contractor will ask the client to put the online review.<br/>10-Any change is considering as extra work and is subject to cost.<br/>11-Contractor to provide the WSIB and Liability insurance upon request.<br/>12-The job will be done by Feb, 10th, 2022 if the quote be accepted by Dec 10th, 2021.<br/>13-Any change is subject to cost. There may be some Extra costs which will be done after requesting and accepting by the client. <br/>14-The models provided below is conceptual to show the understanding of the contractor based on what client explained and the final job may not be look like the same materials, structure, etc.<br/></td><td></td><td></td></tr><tr><td></td><td></td><td>Subtotal</td><td>$19,350</td></tr><tr><td></td><td></td><td>Sales Total</td><td>$20,610</td></tr><tr><td></td><td></td><td>HST/GST</td><td>$2,679</td></tr><tr><td></td><td></td><td>Amount Payable</td><td>$23,289</td></tr><tr><td></td><td></td><td>Amount Paid</td><td>$17,186</td></tr><tr><td></td><td></td><td>Balance</td><td>$16,103</td></tr></table>',
			estimate_version	:	'',
			estimateTemplate	:	'[{"type":"div","children":[{"type":"table","children":[{"type":"table-row","children":[{"type":"image","children":[{"text":""}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"text":"Reno Building Canada Inc.","bold":true}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"650-C Srigley St., Newmarket, ON L3Y 1W9"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"[DOC_TITLE]","h1":true}],"attributes":[{"style":{"padding":"0","margin":"0"}}]}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"text":"WEB : renobuilding.ca"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"PHONE : (416) 821 - 3733"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"EMAIL : info@renoBuilding.ca"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"Prepared by : [USER_NAME], [USER_DESC]"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"type":"paragraph","children":[{"text":"TO : [CLIENT_NAME]","bold":true}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"[CLIENT_ADDRESS]"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"Phone : [CLIENT_PHONE]"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"Prj. Add. : [PROJECT_ADDRESS]"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"text":"Date : [PROJECT_DATE]"},{"type":"paragraph","children":[{"text":"[DOC_TYPE] # : [DOC_NO]"}]},{"type":"paragraph","children":[{"text":"Updated on : [DOC_DATE]"}]}]}]}]}]},{"type":"table","children":[{"type":"table-row","children":[{"type":"table-cell","children":[{"text":"Item No.","bold":true}],"attributes":[{"style":{"width":"50"}}]},{"type":"table-cell","children":[{"text":"Description","bold":true}]},{"type":"table-cell","children":[{"text":"Unit","bold":true}]},{"type":"table-cell","children":[{"text":"Amount","bold":true}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":"1"}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":""}]}]}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":"2"}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]}]}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Subtotal"}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"HST/GST"}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Sales Total"}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Amount Payable"}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Amount Paid"}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Balance"}]},{"type":"table-cell","children":[{"text":"$___"}]}]}]}]}]',
			quote_version		:	'',
			quoteTemplate		:	'[{"type":"div","children":[{"type":"table","children":[{"type":"table-row","children":[{"type":"image","children":[{"text":""}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"text":"Reno Building Canada Inc.","bold":true}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"650-C Srigley St., Newmarket, ON L3Y 1W9"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"[DOC_TITLE]","h1":true}],"attributes":[{"style":{"padding":"0","margin":"0"}}]}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"text":"WEB : renobuilding.ca"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"PHONE : (416) 821 - 3733"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"EMAIL : info@renoBuilding.ca"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"Prepared by : [USER_NAME], [USER_DESC]"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"type":"paragraph","children":[{"text":"TO : [CLIENT_NAME]","bold":true}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"[CLIENT_ADDRESS]"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"Phone : [CLIENT_PHONE]"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"Prj. Add. : [PROJECT_ADDRESS]"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"text":"Date : [PROJECT_DATE]"},{"type":"paragraph","children":[{"text":"[DOC_TYPE] # : [DOC_NO]"}]},{"type":"paragraph","children":[{"text":"Updated on : [DOC_DATE]"}]}]}]}]}]},{"type":"table","children":[{"type":"table-row","children":[{"type":"table-cell","children":[{"text":"Item No.","bold":true}],"attributes":[{"style":{"width":"50"}}]},{"type":"table-cell","children":[{"text":"Description","bold":true}]},{"type":"table-cell","children":[{"text":"Unit","bold":true}]},{"type":"table-cell","children":[{"text":"Amount","bold":true}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":"1"}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":""}]}]}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":"2"}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]}]}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Subtotal"}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"HST/GST"}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Sales Total"}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Amount Payable"}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Amount Paid"}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Balance"}]},{"type":"table-cell","children":[{"text":"$___"}]}]}]}]}]',

		};
		this.onChange = editorState => this.setState({ editorState });

		this.onLoad();

	}
	onLoad(){
		var dataAdapter = new DataAdapter("SELECT prj.*, person.*, pt.* FROM rb_projects prj INNER JOIN rb_project_tasks pt ON pt.prj_id = prj.prj_id LEFT JOIN rb_person person ON prj.client_id = person.person_id WHERE prj.prj_id=" + __PROJECT_ID__ + ";");
		dataAdapter.getRecords()
			.then(data => {
				if (data.length > 0) {
					if(__PROJECT_TASK_ID__) data = data.filter(d=>d.pt_id==__PROJECT_TASK_ID__);
					this.setState({
						projects: data[0],
						project_id: data[0].prj_id,
						project_title: data[0].prj_title,
						project_description: data[0].prj_desc,
						project_address: data[0].prj_address,
						project_city: data[0].prj_city,
						project_postal_code: data[0].prj_postal_code,
						project_category: data[0].prj_category,
						project_posted_date: data[0].prj_posted_date,
						project_start_date: data[0].start_date,
						project_budget: data[0].prj_budget,
						project_category_1: data[0].prj_category_1,

						status		:	data[0].prj_status,
						task_status	:	data[0].task_status,

						client_person_id: data[0].person_id,
						client_name: data[0].name,
						client_lastname: data[0].lastname,
						client_postal_code: data[0].postal_code,
						client_address: data[0].address,
						client_city: data[0].city,
						client_person_tel: data[0].person_tel,
						client_email: data[0].email,

						receiver_id: -1,

						// receiver_id: data[0].person_id,
						// receiver_type: data[0].person_type,
						// receiver_name: data[0].name,
						// receiver_lastname: data[0].lastname,
						// receiver_postal_code: data[0].postal_code,
						// receiver_address: data[0].address,
						// receiver_city: data[0].city,
						// receiver_tel: data[0].person_tel,
						// receiver_email: data[0].email,
					})
					// this.setState({ status: data[0].prj_status.split(';')[0] });
					this.setAccess(cookie.get('v-person-id'), cookie.get('v-person-role'));
				}
			})
			.catch(error => {
				console.error('Error:', error);
			})

		dataAdapter = new DataAdapter(getMyNotes(__PROJECT_ID__, cookie.get('v-person-id')));
		dataAdapter.getRecords()
			.then(data => {
				console.log(getMyNotes(__PROJECT_ID__, cookie.get('v-person-id')))
				this.setState({ mynotes: data[0].note });
			})
			.catch(error => {
				console.error('Error:', error);
			})
	}
	onCreateCloudSpace = (event) => {
		// let _name = this.state.projects.prj_id + ' - ' + this.state.projects.prj_title + ' - ' + this.state.projects.prj_city + ' - ' + this.state.client_name;
		/**
		 * 20230124
		 */
		let _name = this.state.projects.prj_id + ' - ' + this.state.projects.prj_address + ', ' + this.state.projects.prj_city + ' - ' + this.state.projects.prj_title + ' - ' + this.state.client_name + ' ' + this.state.client_lastname;

		let formData = new FormData();
		formData.append("parent", "1RL_oWn5VV1KBzPP723qbxNC2vCWO-vAs");
		formData.append("name", _name);
		console.log(_name);

		fetch(_BACKEND_URL_ + '/folder', {
			method: 'POST',
			body: formData
		})
			.then(response => response.json())
			.then(data => {
				console.log(data);
				let formData;
				// Images
				formData = new FormData();
				formData.append("parent", data);
				formData.append("name", "Images");
				fetch(_BACKEND_URL_ + '/folder', { method: 'POST', body: formData }).then(response => response.json()).then(data => { this.addNotification('Image folder Created'); }).catch(error => { })
				// Images
				formData = new FormData();
				formData.append("parent", data);
				formData.append("name", "Drawings");
				fetch(_BACKEND_URL_ + '/folder', { method: 'POST', body: formData }).then(response => response.json()).then(data => { this.addNotification('Drawing folder Created'); }).catch(error => { })

				formData = new FormData();
				formData.append("parent", data);
				formData.append("name", "Models");
				fetch(_BACKEND_URL_ + '/folder', { method: 'POST', body: formData }).then(response => response.json()).then(data => { this.addNotification('Models folder Created'); }).catch(error => { })

				formData = new FormData();
				formData.append("parent", data);
				formData.append("name", "Orders");
				fetch(_BACKEND_URL_ + '/folder', { method: 'POST', body: formData }).then(response => response.json()).then(data => { this.addNotification('Orders folder Created'); }).catch(error => { })

				formData = new FormData();
				formData.append("parent", data);
				formData.append("name", "Quote");
				fetch(_BACKEND_URL_ + '/folder', { method: 'POST', body: formData }).then(response => response.json()).then(data => { this.addNotification('Quote folder Created'); }).catch(error => { })

				formData = new FormData();
				formData.append("parent", data);
				formData.append("name", "Videos");
				fetch(_BACKEND_URL_ + '/folder', { method: 'POST', body: formData }).then(response => response.json()).then(data => { this.addNotification('Videos folder Created'); }).catch(error => { })

				formData = new FormData();
				formData.append("query", "UPDATE rb_projects SET prj_folder_id = '" + data + "' WHERE prj_id=" + __PROJECT_ID__);
				let requestOptions = {
					method: 'POST',
					headers: {
						'Authorization': 'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')
					},
					body: formData
				};
				fetch('https://renobuilding.ca/wp-json/reno/v1/query/', requestOptions)
					.then(response => {
						return Promise.all([response.json(), response])
					})
					.then(([responseData, response]) => {
						console.log(responseData);
						setTimeout(() => {
							window.location.reload();
						}, 5000)
					})
					.catch(error => {
						console.error('Error:', error);
					})
			})
			.catch(error => {
				console.error(error)
			});
	}

	render() {
		// var _status_ = this.state.status * 1;
		var _status_ = this.state.projects.task_type*1;
		var _action_caption_ = "";
		switch (_status_) {
			case 0:
				_action_caption_ = "Feed Manager";
				break;
			case 1:
				_action_caption_ = "Lead Manager";
				break;
			case 2:
				_action_caption_ = "Verification Manager";
				break;
			case 3:
				_action_caption_ = "Estimate Manager";
				break;
			case 4:
				_action_caption_ = "Appointment Manager";
				break;
			case 5:
				_action_caption_ = "Visit Manager";
				break;
			case 6:
				_action_caption_ = "Quote Manager";
				break;
			case 7:
				_action_caption_ = "Win Manager";
				break;
			case 8:
				_action_caption_ = "Start Project Manager";
				break;
			case 9:
				_action_caption_ = "Progress Project Manager";
				break;
			case 10:
				_action_caption_ = "Project Finish Manager";
				break;
			default:
				break;
		}

		return (
			<Page className="DashboardPage" title={this.state.projects.prj_id + ' - ' + this.state.projects.prj_title} /*breadcrumbs={[{ name: 'Project', active: true }]}*/ >
				<Row style={this.state.__ACCESS_V_ACTIONMANAGER__}>
					<Col md={12} sm={12} xs={12} >
						<Card>
							<ListGroup>
								<ListGroupItem>
									<Accordion defaultActiveKey="1">
										<Accordion.Item eventKey="0">
											<Accordion.Header >Project Detail</Accordion.Header>
											<Accordion.Body>
												<FormGroup row >
													<Col  md={12} sm={12} xs={12}>
														<Card>
															<ListGroup flush>
																<ListGroupItem>
																	<Label md={2}><b>Title</b></Label>
																	{this.state.project_title}
																</ListGroupItem>
																<ListGroupItem>
																	<Label md={2}><b>Description</b></Label>
																	{this.state.project_description}
																</ListGroupItem>
																<ListGroupItem>
																	<Label md={2}><b>Location :</b></Label>																	 
																	{this.state.project_address}, {this.state.project_city}, {this.state.project_postal_code}  
																</ListGroupItem>
																<ListGroupItem>
																	<Label md={2}><b>Received :</b></Label>
																	{this.state.project_posted_date}
																</ListGroupItem>
																<ListGroupItem>
																	<Label md={2}><b>Start Date :</b></Label>
																	{this.state.project_start_date}
																</ListGroupItem>
																<ListGroupItem>
																	<Label md={2}><b>Budget :</b></Label>
																	{this.state.project_budget}
																</ListGroupItem>
																<ListGroupItem>
																	<Label md={2}><b>Contact Name :</b></Label>
																	{this.state.project_contact_name}{'	'}
																	{this.state.project_contact_tel ? <a href={'tel:' + this.state.project_contact_tel}><img src={iconPhone} /></a> : ''}
																</ListGroupItem>
																<ListGroupItem>
																	<Col md={12} sm={12} xs={12} className="mb-3">
																		{this.state.projects.prj_folder_id != null ?
																			<>
																				<Row>
																					{this.state.__UPLOAD & this.state.current != null & false ?
																						<Col md={12} sm={12} xs={12} className="mb-3">
																							<form onSubmit={this.handleImageUpload} style={{ display: 'block' }} >
																								<div className="mb-3">
																									<label htmlFor="formFileMultiple">
																										<i className="btn btn-outline-secondary btn-sm" >Upload</i>
																										<input className="form-control" style={{ display: 'none' }} type="file" id="formFileMultiple" onChange={this.onFileChange} accept="image/*" multiple data-original-title="upload photos" />
																									</label>
																								</div>
																							</form>
																						</Col>
																						: ''}
																				</Row>
																				<Row>
																					<Col md={12} sm={12} xs={12} className="mb-3">
																						<DriveGrid parent={this.state.projects.prj_folder_id} onChildrenChange={(_id) => { this.setState({ current: _id }); }} />
																					</Col>
																				</Row>
																			</>
																			:
																			<>
																				{this.state.__UPLOAD ?
																					<Row>
																						<Col md={12} sm={12} xs={12} className="mb-3">
																							<div className="mb-3">
																								<label htmlFor="btnCreateFolder">
																									<input onClick={this.onCreateCloudSpace} className="form-control" type="button" id="btnCreateFolder" value="Create Cloud Folder" />
																								</label>
																							</div>
																						</Col>
																					</Row>
																					: ''}
																			</>
																		}
																	</Col>
																</ListGroupItem>
															</ListGroup>
														</Card>
													</Col>
												</FormGroup>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="1">
											<Accordion.Header >{_action_caption_}</Accordion.Header>
											<Accordion.Body>
												<FormGroup row >
													<Col  md={12} sm={12} xs={12}>
														<Card>
															<ListGroup flush>
																<ListGroupItem>
																{this.state.__ASSIGNTO ?
																	<>
																		{this.state.projects.task_type * 1 == 0  ?
																			<>
																				Assign to : <ComboBox onChange={(event) => { this.onFollowUp(event) }} table="rb_person" filterField="person_type" filterValue={"8' or person_id='" + this.state.client_person_id} valueField="person_id" displayField="name" />{'	'}
																			</>
																			: ''
																		}
																		{this.state.projects.task_type * 1 == 1  ?
																			<>
																				Assign to : <ComboBox onChange={(event) => { this.onFollowUp(event) }} table="rb_person" filterField="person_type" filterValue={"8' or person_id='" + this.state.client_person_id} valueField="person_id" displayField="name" />{'	'}
																			</>
																			: ''
																		}
																		{this.state.projects.task_type * 1 == 2 ?
																			<>
																				Assign to : <ComboBox onChange={(event) => { this.onFollowUp(event) }} table="rb_person" filterField="person_type" filterValue={"8' or person_id='" + this.state.client_person_id} valueField="person_id" displayField="name" />{'	'}
																				<br/>
																				<button type="button" className="btn btn-outline-primary btn-sm" onClick={(event) => { this.onGrantAccessToClient(event) }} >Grant Access To Client</button>{'	'}
																			</>
																			: ''
																		}
																		{this.state.projects.task_type * 1 == 3 ?
																			<>
																				Assign to Estimator : <ComboBox onChange={(event) => { this.onFollowUp(event) }} table="rb_person" filterField="person_type" filterValue={"8' or person_id='" + this.state.client_person_id} valueField="person_id" displayField="name" />{'	'}
																				<br />
																				<button type="button" className="btn btn-outline-primary btn-sm" onClick={(event) => { this.onProvideEstimate(event) }} >Provide Estimate</button>{'			'}
																			</>
																			: ''
																		}
																		{this.state.projects.task_type * 1 == 4 ?
																			<>
																				Assign to Visit : <ComboBox onChange={(event) => { this.onFollowUp(event) }} table="rb_person" filterField="person_type" filterValue={"8' or person_id='" + this.state.client_person_id} valueField="person_id" displayField="name" />{'	'}
																				<br />
																				<button type="button" className="btn btn-outline-primary btn-sm" onClick={(event) => { this.onSetAppointment(event) }} >Set Appointment</button>{'			'}
																			</>
																			: ''
																		}
																		{this.state.projects.task_type * 1 == 5 ?
																			<>
																				<button type="button" className="btn btn-outline-primary btn-sm" onClick={(event) => { this.onVisited(event) }} >Visit Manager</button>{'			'}
																			</>
																			: ''
																		}
																		{this.state.projects.task_type * 1 == 6 ?
																			<>
																				<button type="button" className="btn btn-outline-primary btn-sm" onClick={(event) => { this.onProvideQuote(event) }} >Provite Quote</button>{'			'}
																			</>
																			: ''
																		}
																		{this.state.projects.task_type * 1 == 7 ?
																			<>
																				Assign to  : <ComboBox onChange={(event) => { this.onFollowUpWin(event) }} table="rb_person" filterField="person_type" filterValue="8" valueField="person_id" displayField="name" />{'	'}
																			</>
																		: ''
																		}
																		{this.state.projects.task_type * 1 == 8 ?
																			<>
																				<button type="button" className="btn btn-outline-primary btn-sm" onClick={(event) => { this.onViewQuote(event) }} >View Quote</button>{'			'}
																			</>
																			: ''
																		}
																	</>
																	: ''}{'			'}
																</ListGroupItem>	
															</ListGroup>
														</Card>
														<br />
														<Card>
															{this.state.setAppointmentModal?
																<>
																<ListGroup flush>
																	<ListGroupItem>
																		<Label md={2}>Date</Label>
																		<Input type="date" onChange={(e) => { this.setState({ appointmentDate: e.target.value }); }} />
																		<Label md={2}>Time</Label>
																		<Input type="time" onChange={(e) => { this.setState({ appointmentTime: e.target.value }); }} />
																	</ListGroupItem>
																</ListGroup>
																</>
															:''}
															{this.state.receiver_id !=-1?
															<ListGroup flush>
															<ListGroupItem>
																<Label>Message Tempates</Label><br />
																<ComboBox onChange={this.onTemplateIdFieldChnageHandler} table="rb_templates" valueField="template_id" displayField="template_name" filterField="template_type" filterValue={this.state.projects.task_type + "' and person_type='" + this.state.receiver_type} order="template_name" />														
																<br />
																<Label>Message Text</Label>
																<textarea style={{ width: '100%', height: '150px' }} onChange={(e) => { this.setState({ othernotes: e.target.value }); }} value={this.state.othernotes} />
																<>
																	<b>Receiver Tel : </b> {this.maskPhone(this.state.receiver_tel)} &nbsp;&nbsp;&nbsp;&nbsp;
																	<Button color="secondary" onClick={(e) => { this.onSendSMSHandler(this.state.othernotes, this.state.receiver_tel); }} >Send SMS</Button>{' '}
																	<Button color="secondary" onClick={(e) => { this.onCallHandler(this.state.othernotes, this.state.receiver_tel); }} >Call</Button>{' '}

																	<b>Receiver e-Mail : </b> {this.state.receiver_email} &nbsp;&nbsp;&nbsp;&nbsp; <Button color="secondary" onClick={(e) => { this.onSendEmailHandler(e); }} >Send E-mail</Button>{' '}
																</>
																<>
																	<button type="button" className="btn btn-outline-secondary btn-sm" onClick={async (event) => { await navigator.clipboard.writeText(this.state.othernotes) }} >COPY MESSAGE</button>{'	'}
																	<Button color="secondary" onClick={(e)=>{this.onSendHandler(this.state.othernotes, this.state.receiver_tel);}} >Send</Button>{' '}
																</>

															</ListGroupItem>
														</ListGroup>
														:''}
														</Card>
														<br />
														<Card>
															<ListGroup flush>
																<ListGroupItem>
																	<Row>
																		<Col>
																			<Label>My notes</Label>{'	'}
																			<button type="button" className="btn btn-outline-primary btn-sm" onClick={(event) => { this.setState({ notepadModal: true }) }} >PEN</button>{'	'}
																			<textarea style={{ width: '100%', height: '200' }} onChange={(e) => { this.setState({ mynotes: e.target.value }); }} onBlur={this.onNoteChange} value={this.state.mynotes} />
																		</Col>
																		<Col>
																			<Label>Task Status</Label><br />
																				<>
																				<button data-status="10" type="button" className="btn btn-success btn-sm" onClick={(event) => { this.onChangeTaskStatus(event) }} >Done</button>{'	'}
																				<button data-status="11" type="button" className="btn btn-warning btn-sm" onClick={(event) => { this.onChangeTaskStatus(event) }} >Issue</button>{'	'}
																				<button data-status="12" type="button" className="btn btn-info btn-sm" onClick={(event) => { this.onChangeTaskStatus(event) }} >Hold</button>{'	'}
																				<button data-status="13" type="button" className="btn btn-danger btn-sm" onClick={(event) => { this.onChangeTaskStatus(event) }} >Cancel</button>{'	'}
																				</>
																		</Col>
																	</Row>
																</ListGroupItem>
															</ListGroup>
														</Card>
														<br />
														<Card>
															<CardBody>
																<CardTitle><b>LOG</b></CardTitle>
																<CardText>
																	<ViewProjectTaskDetails project={__PROJECT_TASK_ID__} />
																</CardText>
															</CardBody>
														</Card>
													</Col>
												</FormGroup>
											</Accordion.Body>
										</Accordion.Item>
									</Accordion>
								</ListGroupItem>
							</ListGroup>
						</Card>
					</Col>
				</Row>
				<NotificationSystem ref={this.notificationSystem} style={NOTIFICATION_SYSTEM_STYLE} />
				{this.estimateForm()}
				{this.quoteForm()}
				{this.notepadForm()}
			</Page>
		);
	}

	runQuery = (query, message) => {
		let formData = new FormData();
		formData.append("query", query);
		let requestOptions = { method: 'POST', headers: { 'Authorization': 'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO') }, body: formData };
		fetch('https://renobuilding.ca/wp-json/reno/v1/query/', requestOptions)
			.then(response => {
				return Promise.all([response.json(), response])
			})
			.then(([responseData, response]) => {
				this.addNotification(message, "success");

			})
			.catch(error => {
				console.error('Error:', error);
			})
	}
	maskPhone = (p) => {
		return (p ? "(" + p.substring(0, 3) + ") " + p.substring(3, 6) + " - " + p.substring(6, 10) : "");
	}
	setAccess = (person_id, person_role) => {
		if (person_role * 1 === 0) { //ADMIN
			this.setState({
				__ACCESS_V_ACTIONMANAGER__	:	{display	:	'block'},
				__ACCESS_V_PROJECTINFO__	:	{display	:	'block'},
				__ACCESS_V_TASKINFO__		:	{display	:	'block'},
				__ACCESS_V_DRIVE__			:	{display	:	'block'},
				__SHARELINK: 1,
				__ASSIGNTO: true,
				__CLOSEJOB: true,
				__STATUS: true,
				__BUDGET: true,
				__PHON: true,
				__NOTES: true,
				__UPLOAD: true,
				__QUOTE: true,
				__TASK: true,
				__LOCATION: true,
				__CLIENT_INFORMATION: true,
				__DESCRIPTION: true,
			});
		}
		if (person_role * 1 === 1 || person_role * 1 === 11) { //MANAGER
			this.setState({
				__ACCESS_V_ACTIONMANAGER__	:	{display	:	'block'},
				__ACCESS_V_PROJECTINFO__	:	{display	:	'block'},
				__ACCESS_V_TASKINFO__		:	{display	:	'block'},
				__ACCESS_V_DRIVE__			:	{display	:	'block'},
				__SHARELINK: 1,
				__ASSIGNTO: true,
				__CLOSEJOB: true,
				__STATUS: true,
				__BUDGET: true,
				__PHON: true,
				__NOTES: true,
				__UPLOAD: true,
				__QUOTE: true,
				__TASK: true,
				__LOCATION: true,
				__CLIENT_INFORMATION: true,
				__DESCRIPTION: true,
			});
		}
		if (person_role * 1 === 2) { //Marketting Specialist
			this.setState({
				__ACCESS_V_ACTIONMANAGER__	:	{display	:	'block'},
				__ACCESS_V_PROJECTINFO__	:	{display	:	'block'},
				__ACCESS_V_TASKINFO__		:	{display	:	'block'},
				__ACCESS_V_DRIVE__			:	{display	:	'block'},
				__SHARELINK: 1,
				__ASSIGNTO: true,
				__CLOSEJOB: true,
				__STATUS: true,
				__BUDGET: true,
				__PHON: true,
				__NOTES: true,
				__UPLOAD: true,
				__QUOTE: true,
				__LOCATION: true,
				__CLIENT_INFORMATION: true,
				__DESCRIPTION: true,
			});
		}
		if (person_role * 1 === 3) { //EMPLOYEE
			this.setState({
				__SHARELINK: 1,
				__ASSIGNTO: true,
				__CLOSEJOB: true,
				__STATUS: true,
				__BUDGET: true,
				__PHON: true,
				__NOTES: true,
				__UPLOAD: true,
				__QUOTE: true,
				__LOCATION: true,
				__CLIENT_INFORMATION: true,
				__DESCRIPTION: true,
			});
		}
		if (person_role * 1 === 5) { //Verifier
			this.setState({
				__ACCESS_V_ACTIONMANAGER__	:	{display	:	'block'},
				__ACCESS_V_PROJECTINFO__	:	{display	:	'block'},
				__ACCESS_V_DRIVE__			:	{display	:	'block'},
				__SHARELINK: 1,
				__ASSIGNTO: true,
				__CLOSEJOB: true,
				__BUDGET: true,
				__PHON: true,
				__NOTES: true,
				__UPLOAD: true,
				__LOCATION: true,
				__CLIENT_INFORMATION: true,
				__DESCRIPTION: true,
			});
		}

		if (person_role * 1 === 6) { //Staff
			this.setState({
				__UPLOAD: true,
				__LOCATION: true,
				__CLIENT_INFORMATION: true,
				__DESCRIPTION: true,
			});
		}

		if (person_role * 1 === 7) { //TRADE PERSON
			this.setState({
				__UPLOAD: true,
				__PHON: true,
				__LOCATION: true,
				__DESCRIPTION: true,
			});
		}

		if (person_role * 1 === 8) { //CLIENT
			this.setState({
				__ACCESS_V_PROJECTINFO__	:	{display	:	'block'},
				__ACCESS_V_DRIVE__			:	{display	:	'block'},
				__UPLOAD: true,
				__QUOTE: true,
				__LOCATION: true,
				__CLIENT_INFORMATION: true,
				__DESCRIPTION: true,
			});
		}

		if (person_role * 1 === 9) { //GUEST
			this.setState({
			});
		}
	}
	getQueryString = (param) => {
		var _result = "";
		var indexOfQuestionMark = window.location.href.indexOf('?');
		if (indexOfQuestionMark == -1)
			return _result;
		var queryString = window.location.href.substring(indexOfQuestionMark);
		var indexOfParam = queryString.indexOf(param + '=');
		var indexOfParamEnd = queryString.indexOf('&', indexOfParam);
		if (indexOfParamEnd == -1)
			_result = queryString.substring(indexOfParam + param.length + 1);
		else
			_result = queryString.substring(indexOfParam + param.length + 1, indexOfParamEnd);

		return _result;
	}


	/**
	 * Update notes
	 * @param {*} key 
	 */
	onNoteChange = (e) => {
		e.persist();
		// this.runQuery("UPDATE rb_project_tasks SET note='" + e.target.value + "' WHERE prj_id =" + this.state.projects.prj_id + " AND receiver_id=" + cookie.get("v-person-id"), "Your Notes has been saved.")
		this.runQuery("UPDATE rb_project_tasks SET note='" + this.state.mynotes + "' WHERE pt_id ="  + __PROJECT_TASK_ID__ , "Your Notes has been saved.");
	}
	///////////////////////
	// Actions
	//
	onFollowUp= (e) => {
		(new DataAdapter("select * from rb_person where person_id = " + e.target.value)).getRecords().then(data=>{
			this.setState({

				receiver_id			:	data[0].person_id,
				receiver_name		:	data[0].name,
				receiver_lastname	:	data[0].lastname,
				receiver_postal_code:	data[0].postal_code,
				receiver_address	:	data[0].address,
				receiver_city		:	data[0].city,
				receiver_tel		:	data[0].person_tel,
				receiver_email		:	data[0].email,
				receiver_type		:	data[0].person_type,
			 });
		})
	}
	onApply=(e)=>{
		if(this. state.templateId==-1){
			this.addNotification("What are you going to do? please select from `Templates`", "error");
			return false;
		}
		switch(e.target.attributes[0].nodeValue*1){
			case 2:
				this.runQuery("INSERT INTO rb_project_tasks (prj_id,sender_id, receiver_id, start_date, task_status,task_type,task,due_date,task_description,expected_end_date,estimate_hours) VALUES (" + __PROJECT_ID__ + "," + cookie.get("v-person-id") + "," + this.state.receiver_id + ",now(), 8,2,'" + this.state.projects.prj_title + "','" + (new Date()).toISOString().split('T')[0] + "','" + this.state.othernotes  + "','" + (new Date()).toISOString().split('T')[0] + "',1);", "Project sent to " + this.state.receiver_name)
				this.runQuery("INSERT INTO rb_project_task_details (pt_id,prj_id,sender_id, receiver_id, start_date, task_status,task_type,task,due_date,task_description,expected_end_date,estimate_hours) VALUES (" + __PROJECT_TASK_ID__  + "," + __PROJECT_ID__ + "," + cookie.get("v-person-id") + "," + this.state.receiver_id + ",now(), 8,2,'" + this.state.projects.prj_title + "','" + (new Date()).toISOString().split('T')[0] + "','" + this.state.othernotes  + "','" + (new Date()).toISOString().split('T')[0] + "',1);", "Project sent to " + this.state.receiver_name)
				break;
			default:
				alert("There's nothing todo!");
		}

	}
	onChangeTaskStatus = (e)=>{
			this.runQuery("UPDATE rb_project_tasks SET task_status=" + e.target.attributes[0].nodeValue + " WHERE pt_id=" + __PROJECT_TASK_ID__, "Task Status Updated.");
			if(e.target.attributes[0].nodeValue*1==10){
				this.runQuery("UPDATE rb_project_tasks SET estimate_hours = ROUND(real_hours/60) WHERE (estimate_hours is null or estimate_hours=0) and  pt_id=" + __PROJECT_TASK_ID__, "Task estimate hours has been updated");
			}
			this.onLoad();	
	}
	onGrantAccessToClient = (e) => {
		this.runQuery("UPDATE rb_person SET user_name = LOWER(name), password=IF(ISNULL(person_tel) OR LENGTH(person_tel)=0, '1234', RIGHT(person_tel,4)), user_expire_date=(NOW() + INTERVAL 30 DAY) WHERE person_id=" + this.state.projects.client_id, 'Client access was created');
		// this.runQuery("INSERT INTO rb_project_tasks (prj_id,sender_id, receiver_id, start_date, task_status,task_type,task,due_date,task_description) values (" + this.state.projects.prj_id + "," + cookie.get("v-person-id") + "," + this.state.projects.client_id + ",now(), 3,3,'" + this.state.othernotes + "','" + this.state.projects.listing_end_date + "','" + this.state.projects.prj_desc + "')", "A Task Assign to Client");
		var __template_grant_access	= 'Dear [CLIENT_NAME],\nWe provided an access to our software (app.renobuilding.ca) for you. Your login is "[CLIENT_ACCOUNT]" and your password is "[CLIENT_PHONE]"';
		__template_grant_access = __template_grant_access
				.replaceAll('[CLIENT_NAME]', this.state.client_name)
				.replaceAll('[CLIENT_ACCOUNT]', this.state.client_name.toLowerCase())
				.replaceAll('[CLIENT_PHONE]', (this.state.client_person_tel?this.state.client_person_tel.substr(-4) : '1234'));
		this.setState({ receiver_id: this.client_id , othernotes:  __template_grant_access });
	}
	// 3->4 Estimator
	onFollowUpEstimate = (e) => {
		var expected_end_date = new Date();
		expected_end_date.setDate(expected_end_date.getDate() + 14);
		var _note	=	'Estimate "' + this.state.projects.prj_title + '"';
		this.setState({ receiver_id: e.target.value, othernotes: _note });

		this.runQuery("INSERT INTO rb_project_tasks (prj_id,sender_id, receiver_id, start_date, task_status,task_type,task,due_date,task_description,expected_end_date,estimate_hours) VALUES (" + this.state.projects.prj_id + "," + cookie.get("v-person-id") + "," + this.state.receiver_id + ",now(), 4,4,'" + this.state.othernotes + "','" + this.state.projects.listing_end_date + "','" + this.state.projects.prj_desc + "','" + expected_end_date + "',1);", "Project sent to follow up.")
		this.runQuery("INSERT INTO rb_project_task_details (prj_id,sender_id, receiver_id, start_date, task_status,task_type,task,due_date,task_description,expected_end_date, expected_start_date) VALUES (" + this.state.projects.prj_id + "," + cookie.get("v-person-id") + "," + this.state.receiver_id + ",now(), 4,92,'" + _note + "','" + this.state.projects.listing_end_date + "','" + this.state.projects.prj_desc + "','" + expected_end_date + "', now());", "Logged")
	}

	// 7->8 Win Manager
	onFollowUpWin = (e) => {
		var expected_end_date = new Date();
		expected_end_date.setDate(expected_end_date.getDate() + 14);
		var _note	=	'Follow up "' + this.state.projects.prj_title + '"';
		this.setState({ receiver_id: e.target.value, othernotes: _note });

		this.runQuery("INSERT INTO rb_project_tasks (prj_id,sender_id, receiver_id, start_date, task_status,task_type,task,due_date,task_description,expected_end_date,estimate_hours) VALUES (" + this.state.projects.prj_id + "," + cookie.get("v-person-id") + "," + e.target.value + ",now(), 7,7,'" + _note + "','" + this.state.projects.listing_end_date + "','" + this.state.projects.prj_desc + "','" + expected_end_date + "',1);", "Project sent to follow up.")
		this.runQuery("INSERT INTO rb_project_task_details (prj_id,sender_id, receiver_id, start_date, task_status,task_type,task,due_date,task_description,expected_end_date, expected_start_date) VALUES (" + this.state.projects.prj_id + "," + cookie.get("v-person-id") + "," + e.target.value + ",now(), 7,92,'" + _note + "','" + this.state.projects.listing_end_date + "','" + this.state.projects.prj_desc + "','" + expected_end_date + "', now());", "Logged")
	}


	onProvideEstimate = (e) => {
		if (this.state.estimateModal) {
			this.runQuery("INSERT INTO rb_project_tasks (task_type,task_status,task,prj_id,sender_id, receiver_id,note) VALUES (3,3,'Estimate Preview'," + this.state.projects.prj_id + "," + cookie.get("v-person-id") + ", " + cookie.get("v-person-id") + ",'" + window.docx.innerHTML + "');", "The quote has been saved.");
			this.runQuery("INSERT INTO rb_project_task_details (pt_id,task_type,task_status,task,prj_id,sender_id, receiver_id,note) VALUES (" + __PROJECT_TASK_ID__ + ",3,3,'Estimate Version'," + this.state.projects.prj_id + "," + cookie.get("v-person-id") + ", " + cookie.get("v-person-id") + ",'" + this.state.estimate_version + "');", "The quote has been saved.");
		} else {
			this.setState({ estimateModal: true });
		}
	}

	onSetAppointment = (e) => {
		if (this.state.setAppointmentModal) {
			// this.runQuery("UPDATE rb_projects SET prj_status = 5 WHERE prj_id=" + this.state.projects.prj_id, "Status Updated.");
			// this.runQuery("INSERT INTO rb_project_tasks (prj_id,sender_id, receiver_id, start_date, task_status,task_type,task,due_date,task_description, appointment_date) values (" + this.state.projects.prj_id + ",0," + cookie.get("v-person-id") + ",now(), 5,5,'" + this.state.othernotes + "','" + this.state.projects.listing_end_date + "','" + this.state.projects.prj_desc + "','" + (this.state.appointmentDate + ' ' + this.state.appointmentTime) + "');", ",Appointment Set")
			this.setState({ setAppointmentModal: false });
		} else {
			this.setState({ receiver_id: e.target.value, othernotes: "Please Visit the job site" });
			this.setState({ setAppointmentModal: true });
		}
	}
	onVisited = (e) => {
		if (this.state.modal) {
			/*
			this.runQuery("UPDATE rb_project_tasks SET note='" + this.state.othernotes + "' WHERE prj_id =" + this.state.projects.prj_id + " AND receiver_id=" + cookie.get("v-person-id") ,"Your Notes has been saved.")
			this.runQuery("UPDATE rb_projects SET prj_status = 6 WHERE prj_id=" + this.state.projects.prj_id,"Project Status chnaged to Quote");
			this.runQuery("UPDATE rb_project_tasks SET task_status = 6, task_type=6 WHERE prj_id=" + this.state.projects.prj_id + " AND receiver_id=" + cookie.get("v-person-id"),"Task Status Updated.");
			*/

			this.runQuery("UPDATE rb_project_tasks SET note='" + this.state.othernotes + "' WHERE pt_id =" + this.state.task, "Your Notes has been saved.")
			this.runQuery("UPDATE rb_projects SET prj_status = 6 WHERE prj_id=" + this.state.projects.prj_id, "Project Status chnaged to Quote");
			this.runQuery("INSERT rb_project_tasks SET task_status = 6, task_type=6 WHERE pt_id=" + this.state.task, "Task Status Updated.");

			this.setState({ modal: false });
		} else {
			this.setState({ receiver_id: e.target.value, othernotes: "" });
			this.setState({ modal: true });
		}
	}
	onProvideQuote = (e) => {
		if (this.state.quoteMdal) {
			this.runQuery("INSERT INTO rb_project_tasks (task_type,task_status,task,prj_id,sender_id, receiver_id,note) VALUES (6,3,'Quote Preview'," + this.state.projects.prj_id + "," + cookie.get("v-person-id") + ", " + cookie.get("v-person-id") + ",'" + window.docx.innerHTML + "');", "The quote has been saved.");
			this.runQuery("INSERT INTO rb_project_task_details (pt_id,task_type,task_status,task,prj_id,sender_id, receiver_id,note) VALUES (" + __PROJECT_TASK_ID__ + ",6,3,'Quote Version'," + this.state.projects.prj_id + "," + cookie.get("v-person-id") + ", " + cookie.get("v-person-id") + ",'" + this.state.quote_version + "');", "The quote has been saved.");
		} else {
			this.setState({ quoteMdal: true });
		}
	}
	onEstimateSend = (e) => {
		this.runQuery("INSERT INTO rb_project_tasks (prj_id,sender_id, receiver_id, start_date, task_status,task_type,task,due_date,task_description, note) values (" + this.state.projects.prj_id + "," + cookie.get("v-person-id") + "," + this.state.projects.client_id + ",now(), 3, 3,'Please, Review your Estimate.','" + this.state.projects.listing_end_date + "','Please, Review your Quote.','" + window.docx.innerHTML + "');", "The Estimate has been Sent to client, successfully.")
		this.setState({ quoteMdal: false });

	}

	onQuoteSend = (e) => {
		//this.runQuery("UPDATE rb_projects SET prj_status = 7 WHERE prj_id=" + this.state.projects.prj_id,"Project Status chnaged to win");
		this.runQuery("INSERT INTO rb_project_tasks (prj_id,sender_id, receiver_id, start_date, task_status,task_type,task,due_date,task_description, note) values (" + this.state.projects.prj_id + "," + cookie.get("v-person-id") + "," + this.state.projects.client_id + ",now(), 3, 6,'Please, Review your Quote.','" + this.state.projects.listing_end_date + "','Please, Review your Quote.','" + window.docx.innerHTML + "');", "The Quote has been Sent to client, successfully.")
		//this.setState({quoteMdal: false});

	}
	onAcceptOrReject = (e) => {
		if (this.state.modal) {
			// this.runQuery("UPDATE rb_projects SET prj_status = 4 WHERE prj_id=" + this.state.projects.prj_id,"Status Updated.");
			// this.runQuery("INSERT INTO rb_project_tasks (prj_id,sender_id, receiver_id, start_date, task_status,task_type,task,due_date,task_description) values (" + this.state.projects.prj_id + "," +cookie.get("v-person-id") + "," + this.state.receiver_id + ",now(), 4,4,'" + this.state.othernotes + "','" + this.state.projects.listing_end_date + "','" + this.state.projects.prj_desc + "');",",Project assigned successfully.")
			if (e.target.innerHTML == 'Accept') {
				this.runQuery("UPDATE rb_project_task_details SET task_status = 8 WHERE pt_id=" + this.state.task, "Quote Accepted");
				this.runQuery("UPDATE rb_projects SET prj_status = 8 WHERE prj_id=" + this.state.projects.prj_id, "Status Updated.");
			}
			if (e.target.innerHTML == 'Reject') {
				this.runQuery("UPDATE rb_project_task_details SET task_status = 20 WHERE pt_id=" + this.state.task, "Quote Rejected");
				this.runQuery("UPDATE rb_projects SET prj_status = 20 WHERE prj_id=" + this.state.projects.prj_id, "Status Updated.");
			}
			this.setState({ modal: false });
		} else {
			// this.setState({receiver_id: e.target.value, othernotes : "Please make an appointment"});
			this.setState({ modal: true });
		}
	}
	onViewQuote = (e) => {
		if (this.state.modal) {
			this.setState({ modal: false });
		} else {
			this.setState({ modal: true });
		}
	}

	///////////////////////
	// Event and Callback handlers

	comboBoxOnChange1 = (key) => {
		this.setState({ modal: true })
		/*
		var _status_ = this.state.status *1;
		var query = "";
		switch (_status_) {
			case 0:
				break;
			case 3:
				this.runQuery("UPDATE rb_projects SET prj_status = 4 WHERE prj_id=" + this.state.projects.prj_id,"Status Updated.");
				this.runQuery("insert into rb_project_tasks (prj_id,sender_id, receiver_id, start_date, task_status,task_type,task,due_date,task_description) values (" + this.state.projects.prj_id + "," +cookie.get("v-person-id") + "," + key.target.value + ",now(), 4,4,'" + this.state.projects.prj_title + "','" + this.state.projects.listing_end_date + "','" + this.state.projects.prj_desc + "');","This project has been Granted, successfully.")
				break;
		}*/

	}
	onVerifiedHandler = (e) => {
		var query = "";
		var _status_ = this.state.status * 1;
		switch (_status_) {
			case 0:
				break;
			case 1:
				break;
			case 2:
				this.runQuery("UPDATE  rb_project_tasks SET task_status=4 WHERE prj_id=" + this.state.projects.prj_id + " AND receiver_id=" + this.state.projects.client_id + "", "Client has been Verified");
				this.runQuery("UPDATE rb_project_tasks SET task_status=3 WHERE prj_id=" + this.state.projects.prj_id + " AND receiver_id=" + cookie.get("v-person-id"), "Task is ready to assign");
				this.runQuery("UPDATE rb_projects SET prj_status = 3 WHERE prj_id=" + this.state.projects.prj_id, 'Project status has ben changed');
				break;
		}
		let formData = new FormData();
		formData.append("query", query);
		let requestOptions = { method: 'POST', headers: { 'Authorization': 'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO') }, body: formData };
		fetch('https://renobuilding.ca/wp-json/reno/v1/query/', requestOptions)
			.then(response => {
				return Promise.all([response.json(), response])
			})
			.then(([responseData, response]) => {
				this.addNotification('This project has been Verified by you, successfully.');
			})
			.catch(error => {
				console.error('Error:', error);
			})
	}
	onHoldHandler = (e) => {
		this.runQuery("UPDATE rb_project_tasks SET task_status = 12 WHERE prj_id=" + this.state.projects.prj_id, "Task has been holded");
		this.runQuery("UPDATE rb_projects SET prj_status = 12 WHERE prj_id=" + this.state.projects.prj_id, "Project has been holded");
	}
	onCloseHandlet = (e) => {
		e.persist();
		var _status_ = this.state.status * 1;
		var query = "";
		switch (_status_) {
			case 0:
				this.runQuery("UPDATE rb_project_tasks SET task_status = task_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Task has been closed");
				this.runQuery("UPDATE rb_projects SET prj_status = prj_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Project has been closed");
				break;
			case 1:
				this.runQuery("UPDATE rb_project_tasks SET task_status = task_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Task has been closed");
				this.runQuery("UPDATE rb_projects SET prj_status = prj_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Project has been closed");
				break;
			case 2:
				this.runQuery("UPDATE rb_project_tasks SET task_status = task_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Task has been closed");
				this.runQuery("UPDATE rb_projects SET prj_status = prj_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Project has been closed");
				break;
			case 3:
				this.runQuery("UPDATE rb_project_tasks SET task_status = 17 WHERE prj_id=" + this.state.projects.prj_id, "Task has been closed");
				this.runQuery("UPDATE rb_projects SET prj_status = 17 WHERE prj_id=" + this.state.projects.prj_id, "Project has been closed");
				break;
			case 4:
				this.runQuery("UPDATE rb_project_tasks SET task_status = task_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Task has been closed");
				this.runQuery("UPDATE rb_projects SET prj_status = prj_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Project has been closed");
				break;
			case 5:
				this.runQuery("UPDATE rb_project_tasks SET task_status = task_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Task has been closed");
				this.runQuery("UPDATE rb_projects SET prj_status = prj_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Project has been closed");
				break;
			case 6:
				this.runQuery("UPDATE rb_project_tasks SET task_status = task_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Task has been closed");
				this.runQuery("UPDATE rb_projects SET prj_status = prj_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Project has been closed");
				break;
			case 7:
				this.runQuery("UPDATE rb_project_tasks SET task_status = task_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Task has been closed");
				this.runQuery("UPDATE rb_projects SET prj_status = prj_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Project has been closed");
				break;
			case 8:
				this.runQuery("UPDATE rb_project_tasks SET task_status = task_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Task has been closed");
				this.runQuery("UPDATE rb_projects SET prj_status = prj_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Project has been closed");
				break;
			case 9:
				this.runQuery("UPDATE rb_project_tasks SET task_status = task_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Task has been closed");
				this.runQuery("UPDATE rb_projects SET prj_status = prj_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Project has been closed");
				break;
			case 10:
				this.runQuery("UPDATE rb_project_tasks SET task_status = task_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Task has been closed");
				this.runQuery("UPDATE rb_projects SET prj_status = prj_status + 13 WHERE prj_id=" + this.state.projects.prj_id, "Project has been closed");
				break;

		}

		let formData = new FormData();
		console.log(query);
		formData.append("query", query);
		let requestOptions = { method: 'POST', headers: { 'Authorization': 'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO') }, body: formData };
		fetch('https://renobuilding.ca/wp-json/reno/v1/query/', requestOptions)
			.then(response => {
				return Promise.all([response.json(), response])
			})
			.then(([responseData, response]) => {
				console.log(responseData);
				this.addNotification('Project status has been Updated!');
			})
			.catch(error => {
				console.error('Error:', error);
			})

	}

	getAppointmentDate = () => {
		(new DataAdapter("SELECT appointment_date FROM rb_project_tasks WHERE prj_id = " + __PROJECT_ID__ + " AND task_type=5 AND task_status=5;"))
			.getRecords()
			.then(data => {
				this.setState({ appointmentDate: data[0].appointment_date })
			});
	}
	onCallHandler = (_text, _receiver) => {
		if (this.state.receiver_tel) {
			window.location.href = 'tel:' + this.state.receiver_tel;
			this.runQuery("INSERT INTO rb_project_task_details (pt_id,prj_id,sender_id, receiver_id, task, task_type, task_description, note, start_date) values (" + __PROJECT_TASK_ID__ + "," + __PROJECT_ID__ + "," + cookie.get("v-person-id") + "," + this.state.receiver_id + ",'CALL', 111,'" + this.state.othernotes + "','', now())","Call log inserted");

			// let formData = new FormData();

			// formData.append('receiver', _receiver);
			// formData.append('text', _text);
			// const options = {
			// 	method: "POST",
			// 	headers: {
			// 		'Authorization': 'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')
			// 	},
			// 	body: formData
			// };

			// fetch('https://node.renobuilding.ca:3001/call', options)
			// 	.then(response => response.json())
			// 	.then(response => {
			// 		console.log(response);
			// 	})
			// 	.catch(err => console.error(err));
		} else {
			this.addNotification("Receiver have no tel")
		}

	}
	onSendSMSHandler = (_text, _receiver) => {
		if (this.state.receiver_tel) {
			let formData = new FormData();

			formData.append('receiver', _receiver);
			formData.append('text', _text);
			const options = {
				method: "POST",
				headers: {
					'Authorization': 'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')
				},
				body: formData
			};

			fetch('https://node.renobuilding.ca:3001/sms', options)
				.then(response => response.json())
				.then(response => {
					this.addNotification('SMS has been sent to ' + this.state.receiver_tel);


				})
				.catch(err => console.error(err));

				this.runQuery("INSERT INTO rb_project_task_details (pt_id,prj_id,sender_id, receiver_id, task, task_type, task_description, note, start_date) values (" + __PROJECT_TASK_ID__ + "," + __PROJECT_ID__ + "," + cookie.get("v-person-id") + "," + this.state.receiver_id + ",'SMS', 111,'" + this.state.othernotes + "','', now())","SMS log inserted");

			} else {
			this.addNotification("Receiver have no tel")
		}

	}
	onSendEmailHandler = () => {
		let formData = new FormData();
		formData.append("from", 'info@renobuilding.ca');
		formData.append("bcc", 'projects@renobuilding.ca');
		formData.append("to", this.state.receiver_email);
		formData.append("subject", 'RE : Prj' + this.state.projects.prj_id + ' - ' + this.state.projects.prj_address + ' - ');
		formData.append("text", this.state.othernotes);
		let requestOptions = { method: 'POST', headers: { 'Authorization': 'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO') }, body: formData };
		fetch('https://node.renobuilding.ca:3001/message', requestOptions)
			.then(response => {
				return Promise.all([response.json(), response])
			})
			.then(([responseData, response]) => {
				console.log(responseData);
				this.addNotification('E-Mail has been sent to ' + this.state.receiver_email);

			})
			.catch(error => {
				console.error('Error:', error);
			})
			this.runQuery("INSERT INTO rb_project_task_details (pt_id,prj_id,sender_id, receiver_id, task, task_type, task_description, note, start_date) values (" + __PROJECT_TASK_ID__ + "," + __PROJECT_ID__ + "," + cookie.get("v-person-id") + "," + this.state.receiver_id + ",'Email',111,'" + this.state.othernotes + "', '', now())","Email log inserted");


	}
	onSendHandler = (_text, _receiver)=>{
		var expected_end_date = (new Date()).toISOString().split('T')[0];
		var _note	=	'Follow up "' + this.state.projects.prj_title + '"';

		this.runQuery("INSERT INTO rb_project_tasks (prj_id,sender_id, receiver_id, start_date, task_status,task_type,task,task_description,expected_end_date,estimate_hours) VALUES (" + this.state.projects.prj_id + "," + cookie.get("v-person-id") + "," + this.state.receiver_id + ",now(), 8," + (this.state.projects.task_type*1+1) + ",'" + _note + "','" + this.state.othernotes + "','" + expected_end_date + "',1);", "Project sent to follow up.")
		this.runQuery("INSERT INTO rb_project_task_details (prj_id, pt_id, sender_id, receiver_id, start_date, task_status,task_type,task,task_description,expected_end_date) VALUES (" + this.state.projects.prj_id + "," + __PROJECT_TASK_ID__ + "," + cookie.get("v-person-id") + "," + this.state.receiver_id + ",now(), 8,92,'" + _note + "','" + this.state.projects.prj_desc + "','" + expected_end_date + "');", "Logged");

	}
	onQuoteSave = (e) => {

	}

	onQuoteSaveToWord = (e) => {
		let _name = this.state.projects.prj_id + ' - ' + this.state.projects.prj_title + ' - ' + this.state.projects.prj_city + ' - ' + this.state.client_name;

		var element = window.docx;
		var title = _name;
		if (!window.Blob) {
			alert('Your browser does not support');
			return;
		}

		var html, link, blob, url, css;

		css = (
			'<style>' +
			'@page WordSection1{size: 210mm 297mmt;mso-page-orientation: portrait;}' +
			'div.WordSection1 {page: WordSection1;}' +
			'* {font-family: Poppins,Tahoma,Arial,sans-serif;}' +
			'.wrapper {width:70%;text-align:center;margin:100px auto;}' +
			'.valid_box {width:100%;border-collapse: collapse;border-width: 1px;}' +
			'table {width: 100%; border: none;}' +
			'table thead th, table th {font-size:12px;color: #ffffff;background-color: gray;border-color: #000;border-style:solid;border-width: 1px;}' +
			'table thead th, table tbody td, table th, table td {font-size:12px;padding: 5px;border-collapse: collapse;border-style:solid;border-width: 1px;}' +
			'.report-header{border: none;}' +
			'</style>'
		);

		html = element.innerHTML;
		blob = new Blob(['\ufeff', css + html], {
			type: 'application/msword'
		});
		url = URL.createObjectURL(blob);
		link = document.createElement('A');
		link.href = url;
		link.download = title;  // default name without extension 
		document.body.appendChild(link);
		if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(blob, title + '.doc'); // IE10-11
		else link.click();  // other browsers
		document.body.removeChild(link);

	}

    addNotification (_MESSAGE_, _TYPE_) {
		const notification = this.notificationSystem.current;
		notification.addNotification({message: _MESSAGE_, level: _TYPE_});
	};	

	actionForm = () => {
		return (
			<>
				<Modal isOpen={this.state.modal} >
					<ModalHeader>
						<Button color="primary" onClick={(e) => { this.setState({ modal: false }) }} >Close</Button>{' '}
						{this.state.status * 1 == 0 ?
							<>
								<Button color="secondary" onClick={(e) => { this.onFollowUp() }} >Apply</Button>{' '}
							</>
							: ''}
						{this.state.status * 1 == 1 ?
							<>
								<Button color="secondary" onClick={(e) => { this.onGrantAccessTo() }} >Apply</Button>{' '}
							</>
							: ''}
						{this.state.status * 1 == 2 ?
							<>
								<Button color="secondary" onClick={(e) => { this.onGrantAccessToClient() }} >Apply</Button>{' '}
							</>
							: ''}
						{this.state.status * 1 == 3 ?
							<>
								<Button color="secondary" onClick={(e) => { this.onAssign() }} >Apply</Button>{' '}
							</>
							: ''}
						{this.state.status * 1 == 4 ?
							<>
								<Button color="secondary" onClick={(e) => { this.onSetAppointment() }} >Apply</Button>{' '}
							</>
							: ''}
						{this.state.status * 1 == 5 ?
							<>
								<Button color="secondary" onClick={(e) => { this.onVisited() }} >Apply</Button>{' '}
							</>
							: ''}
						{this.state.status * 1 == 7 ?
							<>
								<Button color="secondary" onClick={(e) => { this.onVisited() }} >Apply</Button>{' '}
							</>
							: ''}


					</ModalHeader>
					<ModalBody>
						{this.state.appointmentDate + ' ' + this.state.appointmentTime}
						<FormGroup row >
							<Col md={10} >
								{this.state.status * 1 == 4 ?
									<>
										<Label md={2}>Date</Label>
										<Input type="date" onChange={(e) => { this.setState({ appointmentDate: e.target.value }); }} />
										<Label md={2}>Time</Label>
										<Input type="time" onChange={(e) => { this.setState({ appointmentTime: e.target.value }); }} />
									</>
									: ''}
								{this.state.status * 1 == 5 ?
									<>
										<DriveGridUploader parent={this.state.projects.prj_folder_id} onChildrenChange={(_id) => { this.setState({ current: _id }); }} />
									</>
									: ''}
								<br />
								<Label md={2}>Note</Label>
								<textarea style={{ width: '100%', height: '200' }} onChange={(e) => { this.setState({ othernotes: e.target.value }); }} value={this.state.othernotes} />
							</Col>
						</FormGroup>
					</ModalBody>
					<ModalFooter>
					</ModalFooter>
				</Modal>
			</>
		);
	}

	onTemplateTypeFieldChnageHandler = (e) => {
		var __template_type = e.target.value;
		this.setState({ templateType: __template_type });

	}

	getToken = () => {
		//return Base64.btoa(this.state.projects.client_id) + '-' + this.state.projects.client_id + '-' + Date.now();
		return this.state.projects.receiver_id + '-' + this.state.projects.receiver_id + '-' + Date.now();
	}

	onPersonChangeHandler = (e) => {
		this.setState({ receiver_id: e.target.value });
		var dataAdapter = new DataAdapter("select * from rb_person where person_id = " + e.target.value).getRecords().then((data) => {
			this.setState({ receiver_tel: data[0].person_tel, receiver_email: data[0].email })
		});
	}

	onTemplateIdFieldChnageHandler = (e) => {
		var __template_id = e.target.value;
		this.setState({ templateId: __template_id });

		var dataAdapter = new DataAdapter("select * from rb_templates where template_id = " + __template_id);
		dataAdapter.getRecords().then((data) => {
			this.setState({
				othernotes: data[0].task_desc

					.replaceAll('[CLIENT_NAME]', this.state.receiver_name)
					.replaceAll('[CLIENT_PASS]', this.state.receiver_tel.slice(-4))

					.replaceAll('[PROJECT_CODE]', this.state.projects.prj_code)
					.replaceAll('[PROJECT_TITLE]', this.state.projects.prj_title)
					.replaceAll('[PROJECT_TOKEN]', global.config.url + "/#/ViewProject/" + this.state.projects.prj_id + "/" + this.state.task + "?prj_id=" + this.state.projects.prj_id + "&token=" + this.getToken())
					.replaceAll('[PROJECT_LINK]', global.config.url + "/#/ViewProject/" + this.state.projects.prj_id + "/" + this.state.task + "?prj_id=" + this.state.projects.prj_id + "&token=" + this.getToken())
					.replaceAll('[PROJECT_ESTIMATE_LINK]', global.config.url + "/#/ViewProjectTaskNote/" + this.state.projects.prj_id + "/" + this.state.receiver_id + "/3")
					.replaceAll('[PROJECT_QUOTE_LINK]', global.config.url + "/#/ViewProjectTaskNote/" + this.state.projects.prj_id + "/" + this.state.receiver_id + "/6")

					.replaceAll('[USER_NAME]', cookie.get('v-name') + ' ' + cookie.get('v-lastname'))
					.replaceAll('[USER_DESC]', cookie.get('v-person-desc'))
					.replaceAll('[USER_TITLE]', cookie.get('v-person-role-name'))
					.replaceAll('[CELL]', cookie.get('v-tel'))
					.replaceAll('[OFFICE_TEL]', cookie.get('v-tel'))
					.replaceAll('[OFFICE_INFO_EMAIL]', cookie.get('v-email'))
			});
		})

	}

	notepadForm = () => {
		return (
			<>
				<Modal isOpen={this.state.notepadModal} >
					<ModalHeader>
						<Button color="primary" onClick={(e) => { this.setState({ notepadModal: false }) }} >X</Button>{' '}
					</ModalHeader>
					<ModalBody>
						<FormGroup row >
							<Col>
								<NotePad />
							</Col>
						</FormGroup>
					</ModalBody>
					<ModalFooter>
						<Button color="secondary" onClick={(e) => { this.onCallHandler(this.state.othernotes, this.state.receiver_tel); }} >Call</Button>{' '}
					</ModalFooter>
				</Modal>
			</>
		);
	}

	toolbarOptions = [
		['bold', 'italic', 'underline', 'strike'],        // toggled buttons
		['blockquote', 'code-block'],

		[{ 'header': 1 }, { 'header': 2 }],               // custom button values
		[{ 'list': 'ordered' }, { 'list': 'bullet' }],
		[{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
		[{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
		[{ 'direction': 'rtl' }],                         // text direction

		[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
		[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

		[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
		[{ 'font': [] }],
		[{ 'align': [] }],

		['clean'],
		['log']                                         // remove formatting button
	];
	modules = {
		toolbar: {
			container: this.toolbarOptions,
			handlers: {
				'log': (v) => {
					console.log(this.state.convertedText);
				},
			},
		},
		table: false, // disable table module
		'better-table': {
			operationMenu: {
				items: {
					unmergeCells: {
						text: 'Another unmerge cells name'
					}
				},
				color: {
					colors: ['green', 'red', 'yellow', 'blue', 'white'],
					text: 'Background Colors:'
				}
			}
		}
	}

	onEstimateEditorChange(e){
		this.setState({estimate_version	: e});
	}
	onEstimateChnageHandler=(e)=>{
		(new DataAdapter("SELECT * FROM rb_project_task_details WHERE ptd_id = " + e.target.value ))
			.getRecords()
			.then(data=>{
				if(data)
					if(data[0])
						this.setState({estimateTemplate	:	data[0].note});
			})
	}
	estimateForm = () => {
		// var estimateTemplate = '[{"type":"div","children":[{"type":"table","children":[{"type":"table-row","children":[{"type":"image","children":[{"text":""}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"text":"Reno Building Canada Inc.","bold":true}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"650-C Srigley St., Newmarket, ON L3Y 1W9"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"[DOC_TITLE]","h1":true}],"attributes":[{"style":{"padding":"0","margin":"0"}}]}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"text":"WEB : renobuilding.ca"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"PHONE : (416) 821 - 3733"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"EMAIL : info@renoBuilding.ca"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"Prepared by : [USER_NAME], [USER_DESC]"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"type":"paragraph","children":[{"text":"TO : [CLIENT_NAME]","bold":true}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"[CLIENT_ADDRESS]"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"Phone : [CLIENT_PHONE]"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"Prj. Add. : [PROJECT_ADDRESS]"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"text":"Date : [PROJECT_DATE]"},{"type":"paragraph","children":[{"text":"[DOC_TYPE] # : [DOC_NO]"}]},{"type":"paragraph","children":[{"text":"Updated on : [DOC_DATE]"}]}]}]}]}]},{"type":"table","children":[{"type":"table-row","children":[{"type":"table-cell","children":[{"text":"Item No.","bold":true}],"attributes":[{"style":{"width":"50"}}]},{"type":"table-cell","children":[{"text":"Description","bold":true}]},{"type":"table-cell","children":[{"text":"Unit","bold":true}]},{"type":"table-cell","children":[{"text":"Amount","bold":true}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":"1"}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"type":"list","children":[{"text":"Demo, takeout and disposal the shower, vanity, toilet and floor"}]},{"type":"list","children":[{"text":"Renew 40 by 40 standing shower"}]},{"type":"list","children":[{"text":"Complete Waterproof the shower area and floor"}]},{"type":"list","children":[{"text":"Tile the Shower ‘s Floor and walls and grout the tile area"}]},{"type":"list","children":[{"text":"Tile the bathroom floor and group"}]},{"type":"list","children":[{"text":"Tile the Jacuzzi surround"}]},{"type":"list","children":[{"text":""}]}]}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"$19,350"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":"2"}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"type":"list","children":[{"text":"Demo, takeout and disposal the floor for plumbing"}]},{"type":"list","children":[{"text":"Install new standing shower"}]},{"type":"list","children":[{"text":"Tile the bathroom floor and grout"}]},{"type":"list","children":[{"text":"Plumbing for install the new shower, new toilet and re-install existing vanity"}]},{"type":"list","children":[{"text":"Cleaning"}]}]}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"$19,350"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Subtotal"}]},{"type":"table-cell","children":[{"text":"$19,350"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"HST/GST"}]},{"type":"table-cell","children":[{"text":"$20,610"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Sales Total"}]},{"type":"table-cell","children":[{"text":"$20,610"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Amount Payable"}]},{"type":"table-cell","children":[{"text":"$23,289"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Amount Paid"}]},{"type":"table-cell","children":[{"text":"$17,186"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Balance"}]},{"type":"table-cell","children":[{"text":"$16,103"}]}]}]}]}]';
		(new DataAdapter("SELECT * FROM rb_project_task_details WHERE pt_id = " + __PROJECT_TASK_ID__ + " AND task='Estimate Version' ORDER BY ptd_id DESC LIMIT 1;"))
			.getRecords()
			.then(data=>{
				if(data)
					if(data[0])
						this.setState({estimateTemplate	:	data[0].note});
			})
		var estimateTemplate;
		estimateTemplate = this.state.estimateTemplate
			.replaceAll('[CLIENT_NAME]', this.state.client_name + ' ' + this.state.client_lastname)
			.replaceAll('[CLIENT_PHONE]', this.maskPhone(this.state.client_person_tel))
			.replaceAll('[CLIENT_ADDRESS]', (this.state.client_address + ", " + this.state.client_city + ", " + this.state.client_postal_code))

			.replaceAll('[PROJECT_CODE]', this.state.projects.prj_code)
			.replaceAll('[PROJECT_ADDRESS]', (this.state.project_address + ", " + this.state.project_city + ", " + this.state.project_postal_code))
			.replaceAll('[PROJECT_TITLE]', this.state.projects.prj_title)
			.replaceAll('[PROJECT_YEAR]', (new Date()).getFullYear().toString().slice(-2))
			.replaceAll('[PROJECT_DATE]', this.state.project_posted_date)

			.replaceAll('[DOC_TITLE]', "ESTIMATE")
			.replaceAll('[DOC_TYPE]', "Estimate")
			.replaceAll('[DOC_NO]', (new Date()).getFullYear().toString().slice(-2) + '-E-' + this.state.projects.prj_code)
			.replaceAll('[DOC_DATE]', (new Date()).toISOString().split('T')[0])

			.replaceAll('[USER_NAME]', cookie.get('v-name') + ' ' + cookie.get('v-lastname'))
			.replaceAll('[USER_DESC]', cookie.get('v-person-desc'));

		const initialValue = JSON.parse(estimateTemplate);
		return (
			<>
				<Modal isOpen={this.state.estimateModal} >
					<ModalHeader>
						<h6>Estimate Quantities and Prices</h6>
						<>
							<ComboBox onChange={this.onEstimateChnageHandler} table="rb_project_task_details" valueField="ptd_id" displayField="task,ptd_id" filterField="pt_id" filterValue={__PROJECT_TASK_ID__ + "' AND task LIKE '%Estimate%"} order="ptd_id" />														
							<Button color="secondary" onClick={(e) => { this.onEstimateSend(e) }} >Send Estimate</Button>{' '}
							<Button color="primary" target="_blank" href={'/#/ViewProjectTaskNote/' + __PROJECT_ID__ + '/' + cookie.get("v-person-id") + '/3'} >Preview Estimate</Button>{' '}
						</>
					</ModalHeader>
					<ModalBody>
						<VtxEditor initialValue={initialValue} onChange={(e)=>{this.onEstimateEditorChange(e)}} />
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={(e) => { this.setState({ estimateModal: false }) }} >Cancel</Button>{' '}
						<Button color="secondary" onClick={(e) => { this.onProvideEstimate(e) }} >Save</Button>{' '}
					</ModalFooter>
				</Modal>
			</>
		);
	}

	onQuoteEditorChange(e){
		this.setState({quote_version	: e});
	}
	quoteForm = () => {
		// var quoteTemplate = '[{"type":"div","children":[{"type":"table","children":[{"type":"table-row","children":[{"type":"image","children":[{"text":""}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"text":"Reno Building Canada Inc.","bold":true}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"650-C Srigley St., Newmarket, ON L3Y 1W9"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"[DOC_TITLE]","h1":true}],"attributes":[{"style":{"padding":"0","margin":"0"}}]}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"text":"WEB : renobuilding.ca"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"PHONE : (416) 821 - 3733"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"EMAIL : info@renoBuilding.ca"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"Prepared by : [USER_NAME], [USER_DESC]"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"type":"paragraph","children":[{"text":"TO : [CLIENT_NAME]","bold":true}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"[CLIENT_ADDRESS]"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"Phone : [CLIENT_PHONE]"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]},{"type":"paragraph","children":[{"text":"Prj. Add. : [PROJECT_ADDRESS]"}],"attributes":[{"style":{"padding":"0","margin":"0"}}]}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"text":"Date : [PROJECT_DATE]"},{"type":"paragraph","children":[{"text":"[DOC_TYPE] # : [DOC_NO]"}]},{"type":"paragraph","children":[{"text":"Updated on : [DOC_DATE]"}]}]}]}]}]},{"type":"table","children":[{"type":"table-row","children":[{"type":"table-cell","children":[{"text":"Item No.","bold":true}],"attributes":[{"style":{"width":"50"}}]},{"type":"table-cell","children":[{"text":"Description","bold":true}]},{"type":"table-cell","children":[{"text":"Unit","bold":true}]},{"type":"table-cell","children":[{"text":"Amount","bold":true}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":"1"}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":""}]}]}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":"2"}]},{"type":"table-cell","children":[{"type":"paragraph","children":[{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]},{"type":"list","children":[{"text":"..."}]}]}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Subtotal"}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"HST/GST"}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Sales Total"}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Amount Payable"}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Amount Paid"}]},{"type":"table-cell","children":[{"text":"$___"}]}]},{"type":"table-row","children":[{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":""}]},{"type":"table-cell","children":[{"text":"Balance"}]},{"type":"table-cell","children":[{"text":"$___"}]}]}]}]}]';
		(new DataAdapter("SELECT * FROM rb_project_task_details WHERE pt_id = " + __PROJECT_TASK_ID__ + " AND task='Quote Version' ORDER BY ptd_id DESC LIMIT 1;"))
			.getRecords()
			.then(data=>{
				if(data)
					if(data[0])
						this.setState({quoteTemplate	:	data[0].note});
			})

			var quoteTemplate;
			quoteTemplate = this.state.quoteTemplate
			.replaceAll('[CLIENT_NAME]', this.state.client_name + ' ' + this.state.client_lastname)
			.replaceAll('[CLIENT_PHONE]', this.maskPhone(this.state.client_person_tel))
			.replaceAll('[CLIENT_ADDRESS]', (this.state.client_address + ", " + this.state.client_city + ", " + this.state.client_postal_code))

			.replaceAll('[PROJECT_CODE]', this.state.projects.prj_code)
			.replaceAll('[PROJECT_ADDRESS]', (this.state.project_address + ", " + this.state.project_city + ", " + this.state.project_postal_code))
			.replaceAll('[PROJECT_TITLE]', this.state.projects.prj_title)
			.replaceAll('[PROJECT_YEAR]', (new Date()).getFullYear().toString().slice(-2))
			.replaceAll('[PROJECT_DATE]', this.state.project_posted_date)

			.replaceAll('[DOC_TITLE]', "QUOTE")
			.replaceAll('[DOC_TYPE]', "Quote")
			.replaceAll('[DOC_NO]', (new Date()).getFullYear().toString().slice(-2) + '-Q-' + this.state.projects.prj_code)
			.replaceAll('[DOC_DATE]', (new Date()).toISOString().split('T')[0])

			.replaceAll('[USER_NAME]', cookie.get('v-name') + ' ' + cookie.get('v-lastname'))
			.replaceAll('[USER_DESC]', cookie.get('v-person-desc'));

		const initialValue = JSON.parse(quoteTemplate);

		return (
			<>
				<Modal isOpen={this.state.quoteMdal} >
					<ModalHeader>
						<h6>Quote Quantities and Prices</h6>
						<>
							<ComboBox onChange={this.onTemplateIdFieldChnageHandler} table="rb_project_task_details" valueField="ptd_id" displayField="task,ptd_id" filterField="pt_id" filterValue={__PROJECT_TASK_ID__ + "' and task='Quote Version"} order="ptd_id" />														
							<Button style={{float:'right'}} color="primary" onClick={(e) => { this.setState({ quoteMdal: false }) }} >X</Button>{' '}
						</>
					</ModalHeader>
					<ModalBody>
						<VtxEditor initialValue={initialValue} onChange={(e)=>{this.onQuoteEditorChange(e)}} />
					</ModalBody>
					<ModalFooter>
						<Button color="secondary" onClick={(e) => { this.onProvideQuote(e) }} >Save</Button>{' '}
						<Button color="primary" target="_blank" href={'/#/ViewProjectTaskNote/' + __PROJECT_ID__ + '/' + cookie.get("v-person-id") + '/6'} >Preview Quote</Button>{' '}
						<Button color="secondary" onClick={(e) => { this.onQuoteSend(e) }} >Send Quote</Button>{' '}
						<Button color="secondary" onClick={(e) => { this.onQuoteSaveToWord(e) }} >Save as Word</Button>{' '}
						{/* <Button color="secondary" onClick={(e) => { this.onQuoteSave(e) }} >Save as Excel</Button>{' '}
						<Button color="secondary" onClick={(e) => { this.onQuoteSave(e) }} >Save as PDF</Button>{' '} */}
					</ModalFooter>
				</Modal>
			</>
		);
	}

	quoteTemplate = () => {
		return (
			<div class="report-frame" >
				<div class="report-panel" >
					<div class="report-filter">
					</div>
					<div class="report-tools" >
					</div>
					<div class="clear"></div>
				</div>
				<div class="report-body" id="docx" >
					<table class="report-header" >
						<tr>
							<td>
								<b>Reno Building Canada Inc. </b>
								<p>
									<b>O :</b> (416) 821-FREE <br />
									<b>A :</b> C, 650 Srigley St., Newmarket <br />
									<b>E :</b> info@renoBuilding.ca <br />
									<b>Prepared by : </b> Mahyar T., CEO <br />
								</p>
							</td>
							<td></td>
							<td>
								<h1>QUOTE</h1>
							</td>
						</tr>
						<tr>
							<td></td>
							<td></td>
							<td>
								<b>Date :</b> 15-12-2022 <br />
								<b>Quote # :</b> 110-221-Q-451 <br />
								<b>Updated on :</b> 15-12-2022
							</td>
						</tr>
						<tr>
							<td></td>
							<td></td>
							<td>
								<b>To :</b> Dr. David Hung <br />
								<b>Address :</b>
								116 Conover Ave,
								Aurora ON
								(647) 989-5200 <br />
								<b>Client ID :</b> 5200-DH
							</td>
						</tr>
					</table>
					<table class="report-table">
						<tr class="report-table-header" >
							<th>Item No.</th>
							<th>Description</th>
							<th>Unit</th>
							<th>Amount</th>
						</tr>
						<tr>
							<td>1</td>
							<td>
								En-suite bathroom: <br />
								- Demo, takeout and disposal the shower, vanity, toilet and floor <br />
								- Renew 40 by 40 standing shower<br />
								- Complete Waterproof the shower area and floor<br />
								- Tile the Shower ‘s Floor and walls and grout the tile area<br />
								- Tile the bathroom floor and grout<br />
								-Tile the Jacuzzi surround<br />
								- Plumbing for takeout the old fixtures and install the shower, vanity and toilet<br />
								- Electrical for new fan and the shower ceiling light.<br />
								- Install the shower glass<br />
								- Install a fan for bathroom<br />
								- Install other accessories and light.<br />
								- Install baseboards<br />
								-Cleaning<br />
							</td>
							<td></td>
							<td>$19,350</td>
						</tr>
						<tr>
							<td>2</td>
							<td>
								Basement bathroom: <br />
								- Demo, takeout and disposal the floor for plumbing <br />
								- Install new standing shower <br />
								- Tile the bathroom floor and grout<br />
								- Plumbing for install the new shower, new toilet and re-install existing vanity <br />
								- Cleaning<br />
							</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>3</td>
							<td>
								1-	There may have some dust, noise and mud during the construction.<br />
								2-	Client is taking the responsibility for the Town permit and related costs<br />
								3-	Client to take out their stuffs from the working area.<br />
								4-	Client to providing visible materials or pay to contractor based on the store receipt. The selectable materials by client including but not limited the vanity, toilet, shower, fixtures, tiles, glass, accessories, fan, lights, etc. <br />
								5-	Client to pay 10% on acceptance, 50% on start day and 40% on end day <br />
								6-	The building materials is under the suppliers’ warranty<br />
								7-	The shower is warranty for one year. <br />
								8-	The quote is valid for one month<br />
								9-	Contractor will ask the client to put the online review.<br />
								10-	Any change is considering as extra work and is subject to cost.<br />
								11-	Contractor to provide the WSIB and Liability insurance upon request.<br />
								12-	The job will be done by Feb, 10th, 2022 if the quote be accepted by Dec 10th, 2021.<br />
								13-	Any change is subject to cost. There may be some Extra costs which will be done after requesting and accepting by the client. <br />
								14-	The models provided below is conceptual to show the understanding of the contractor based on what client explained and the final job may not be look like the same materials, structure, etc.<br />
							</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td></td>
							<td></td>
							<td>Subtotal</td>
							<td>$19,350</td>
						</tr>
						<tr>
							<td></td>
							<td></td>
							<td>Sales Total</td>
							<td>$20,610</td>
						</tr>
						<tr>
							<td></td>
							<td></td>
							<td>HST/GST</td>
							<td>$2,679</td>
						</tr>
						<tr>
							<td></td>
							<td></td>
							<td>Amount Payable</td>
							<td>$23,289</td>
						</tr>
						<tr>
							<td></td>
							<td></td>
							<td>Amount Paid</td>
							<td>$17,186</td>
						</tr>
						<tr>
							<td></td>
							<td></td>
							<td>Balance</td>
							<td>$16,103</td>
						</tr>
					</table>
					<dir class="clear"></dir>
				</div>
				<dir class="clear"></dir>
			</div>
		);
	}
}

export default ViewProject;